export function normLabel(item: {tipo: string; numero: string; anio: number}): string {
  return `${item.tipo.replace('_', ' ')} ${item.numero}/${item.anio}`
}

export function normLabelProsa(item: {tipo: string; numero: string; anio: number}): string {
  return normLabel(item).replace(/^./, (c) => c.toUpperCase())
}
